<template lang="pug">
    v-container.date-range-picker.px-6(fluid)
        v-row.px-2(v-if="visibleHeader")
            v-col(cols="12")
                h4.mb-0.primaryHover--text.border.primary-header.font-weight-bold {{title}}
        template(v-if="(specificTime || timeEnabled) && !isRange")
            v-row.px-2
                //- FROM =============================================================
                v-col.py-0(cols="6")
                    //- DATE ...........
                    app-datetime-picker(
                        v-model="localDateFrom",
                        :disabled="disableDateFrom",
                        :externalValue="existingValueFrom",
                        pickerType="Date",
                        :textFieldProps="displayableErrors('From')",
                        :label="datePickerLabel('DateFrom')",
                        :tz="timezone",
                        :offset.sync="offsetFrom",
                    )
                v-col.py-0(cols="3")
                    //- TIME from............
                    app-datetime-picker(
                        v-if="timeEnabled",
                        v-model="localTimeFrom",
                        :disabled="disableTimeFrom",
                        :externalValue="existingValueFrom",
                        pickerType="Time"
                        :textFieldProps="displayableErrors('From')",
                        :label="datePickerLabel('TimeFrom')",
                        :tz="timezone",
                        :offset.sync="offsetFrom",
                    )
                v-col.py-0(cols="3")
                    //- TIME to...........
                    app-datetime-picker(
                        v-if="timeEnabled",
                        v-model="localTimeTo",
                        :disabled="disableTimeTo",
                        :externalValue="existingValueTo",
                        pickerType="Time",
                        :textFieldProps="displayableErrors('To')",
                        :label="datePickerLabel('TimeTo')",
                        :tz="timezone",
                        :offset.sync="offsetTo",
                    )
        //- IF NOT REQUIRED THE TWO TIME SELECTORS IN SAME ROW
        template(v-else)
            v-row.px-2
                //- FROM =============================================================
                v-col.py-0(cols="6")
                    //- DATE ...........
                    app-datetime-picker(
                        v-model="localDateFrom",
                        :disabled="disableDateFrom",
                        :externalValue="existingValueFrom",
                        pickerType="Date",
                        :textFieldProps="displayableErrors('From')",
                        :label="datePickerLabel('DateFrom')",
                        :tz="timezone",
                        :offset.sync="offsetFrom",
                    )
                v-col.py-0(cols="6")
                    //- TIME............
                    app-datetime-picker(
                        v-if="timeEnabled",
                        v-model="localTimeFrom",
                        :disabled="disableTimeFrom",
                        :externalValue="existingValueFrom",
                        pickerType="Time"
                        :textFieldProps="displayableErrors('From')",
                        :label="datePickerLabel('TimeFrom')",
                        :tz="timezone",
                        :offset.sync="offsetFrom",
                    )
            v-row.px-2
                //- TO =============================================================
                v-col.py-0(cols="6")
                    //- DATE ...........
                    app-datetime-picker(
                        v-if="isRange",
                        v-model="localDateTo",
                        :disabled="disableDateTo",
                        :externalValue="existingValueTo",
                        pickerType="Date"
                        :textFieldProps="displayableErrors('To')",
                        :label="datePickerLabel('DateTo')",
                        :tz="timezone",
                        :offset.sync="offsetTo",
                    )
                v-col.py-0(cols="6")
                    //- TIME ...........
                    app-datetime-picker(
                        v-if="timeEnabled && isRange",
                        v-model="localTimeTo",
                        :disabled="disableTimeTo",
                        :externalValue="existingValueTo",
                        pickerType="Time",
                        :textFieldProps="displayableErrors('To')",
                        :label="datePickerLabel('TimeTo')",
                        :tz="timezone",
                        :offset.sync="offsetTo",
                    )
        //- CHECKBOXES (Always the same)
        v-row.px-2
            v-col.py-0(cols="6")
                v-checkbox(
                    v-model="timeEnabled"
                    :label="checkBoxLabel"
                    color="primary",
                    on-icon="mdi-checkbox-marked-outline",
                )
            v-col.py-0(cols="6")
                v-checkbox(
                    v-model="isRange"
                    :label="$t('Common.dateRange')",
                    color="primary",
                    on-icon="mdi-checkbox-marked-outline",
                )

</template>

<style scoped>

</style>

<script>
import moment from 'moment-timezone'
export default {
    props: {
        type: {
            type: String,
            default: null
        },
        timezone: {
            type: String,
            default: 'Etc/GMT',
        },
        datetimeFrom: {
            type: String,
            default: null
        },
        datetimeTo: {
            type: String,
            default: null
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        timeFormat: {
            type: String,
            default: 'HH:mm'
        },
        specificTime: {
            type: Boolean,
            default: false
        },
        parentName: {
            type: String,
            default: null
        },
        parentIndex: {
            type: Number,
            default: null
        },
        //- VISUAL PROPS: used to hide, disable or override fields/
        visibleHeader: {
            type: Boolean,
            default: true
        },
        hideDatetimeTo: {
            type: Boolean,
            default: false
        },
        disableDateFrom: {
            type: Boolean,
            default: false
        },
        disableTimeFrom: {
            type: Boolean,
            default: false
        },
        disableDateTo: {
            type: Boolean,
            default: false
        },
        disableTimeTo: {
            type: Boolean,
            default: false
        },
        disableCheckFrom: {
            type: Boolean,
            default: false
        },
        disableCheckTo: {
            type: Boolean,
            default: false
        },
        labelDateFrom: null,
        labelTimeFrom: null,
        labelDateTo: null,
        labelTimeTo: null,
        labelSpecificTimeFrom: null,
        labelSpecificTimeTo: null,
        errors: {
            type: Object,
            default: () => ({}),
        },
       
    },
    data: function () {
        return {
            timeEnabled: false,
            isRange: false,
            valuesFrom: null,
            valuesTo: null,
            isFirstLoad: true,
            //- Local values of each picker
            localDateFrom: null,
            localTimeFrom: null,
            localDateTo: null,
            localTimeTo: null,
            localTimeEnabledFrom: null,
            localTimeEnabledTo: null,
            originalValueFrom: null,
            originalValueTo: null,
            offsetFrom: null,
            offsetTo: null,
        }
    },
    computed: {
        /*
            [COMPUTED] Returns the title to be displayed on the Date Range Picker component at the top of selectors.
        */
        title() {
            return this.$t('Common.requestedDate', {type: this.type});
        },
        /*
            [COMPUTED] Returns a string that represents the output format to display datetime values.
        */
        fullFormat() {
            return this.dateFormat + ' ' + this.timeFormat;
        },
        /*
            [COMPUTED] Returns the label to be displayed on the checkbox of Specific time according the type of range selector (Pickup or Delivery)
        */
        checkBoxLabel() {
            return this.$t('Common.specificTime', {type: this.type});
        },
        /*
            [COMPUTED] Returns the value in ISO format of the full datetime (YYYY-MM-ddTHH:mm+/-HH:mm) - FROM
        */
        completeDateFrom() {
            if(this.localDateFrom && this.localTimeFrom) {
                return `${this.localDateFrom}T${this.localTimeFrom}:00${this.offsetFrom}`;
            }else if(this.localDateFrom && !this.timeEnabled){
                return `${this.localDateFrom}T00:00:00${this.offsetFrom}`;
            }
            return null;
        },
        /*
            [COMPUTED] Returns the value in ISO format of the full datetime (YYYY-MM-ddTHH:mm+/-HH:mm) - TO
        */
        completeDateTo() {
            if(this.localDateTo && this.localTimeTo){
                return `${this.localDateTo}T${this.localTimeTo}:00${this.offsetTo}`;
            }else if(this.localDateTo && !this.timeEnabled){
                return `${this.localDateTo}T00:00:00${this.offsetTo}`;
            }else if(this.localTimeTo && this.localDateFrom){
                return `${this.localDateFrom}T${this.localTimeTo}:00${this.offsetTo}`;
            }
            return null;
        },
        /*
            [COMPUTED] Returns the values from [initial datetime] in the date format.
        */
        dateFrom() {
            return this.valuesFrom ? this.valuesFrom.format(`${this.dateFormat}`) : null;
        },
        /*
            [COMPUTED] Returns the values to [final datetime] in the date format.
        */
        dateTo() {
            return this.valuesTo ? this.valuesTo.format(`${this.dateFormat}`) : null;
        },
        //- Generates a formatted value for being injected as existing value on the pickers.
        existingValueFrom() {
            return this.datetimeFrom ? moment.parseZone(this.datetimeFrom).format(this.fullFormat) : null;
        },
        existingValueTo() {
            return this.datetimeTo ? moment.parseZone(this.datetimeTo).format(this.fullFormat) : null;
        },
        /*
            [COMPUTED] Returns the path for errors on datetime pickers.
        */
        errorsPath() {
            return this.parentIndex != null ? `${this.parentName}[${this.parentIndex}]` : `${this.parentName}`;
        }
    },
    watch: {
        completeDateFrom(values) {
            this.$emit('update:datetimeFrom', values);
        },
        completeDateTo(values) {
            this.$emit('update:datetimeTo', values);
        },
        timeEnabled(value) {
            this.$emit('update:specificTime', value);
        },
        /*
            [WATCHER] When the offsetFrom is changed, update the offsetTo to same value. This ensures the range shares same timezone always.
            NOTE: THIS IS NOT REFLECTING ON UI YET - Check reactivity to fix this in order to avoid confussion with users.
            Functionality is working properly tho.
        */
        offsetFrom: {
            immediate: true,
            handler(val) {
                if(val) this.offsetTo = val;
            }
        },
         /*
            [WATCHER] When the offsetTo is changed, update the offsetFrom value. This ensures the range shares same timezone always.
            NOTE: THIS IS NOT REFLECTING ON UI YET - Check reactivity to fix this in order to avoid confussion with users.
            Functionality is working properly tho.
        */
        offsetTo: {
            immediate: true,
            handler(val) {
                if(val) this.offsetFrom = val;
            }
        },
        /*
            [WATCHER] When the datetimeFrom is updated, transform it and substract its date and its time in order to use their values.
            IMPORTANT ! Use parseZone to avoid timezones changes on time values when using moment.
            If there's no range selected, provide same value of the localDateFrom to the localDateTo.
        */
        datetimeFrom: {
            immediate: true,
            handler(val) {
                if(val) {
                    //If value is not initialized, store it as original Value.
                    if(!this.originalValueFrom) this.originalValueFrom = val;

                    let momentDate = moment.parseZone(val);
                    // -CHANGE let momentDate = moment.tz(val, this.timezone);
                    this.localDateFrom = momentDate.format(this.dateFormat);
                    this.localTimeFrom = momentDate.format(this.timeFormat);
                    //If there is not dates range, apply to date to too.
                    if(!this.isRange){
                        this.localDateTo = this.localDateFrom;
                        this.offsetTo = this.offsetFrom;
                    }
                }
            }
        },
        /*
            [WATCHER] When the datetimeTo is updated, transform it and substract its date and its time in order to use their values.
            IMPORTANT ! Use parseZone to avoid timezones changes on time values when using moment.
        */
        datetimeTo: {
            immediate: true,
            handler(val) {
                if(val) {
                    //If value is not initialized, store it as original Value.
                    if(!this.originalValueTo) this.originalValueTo = val;

                    let momentDate = moment.parseZone(val);
                    // -CHANGE let momentDate = moment.tz(val, this.timezone);
                    this.localDateTo = momentDate.format(this.dateFormat);
                    this.localTimeTo = momentDate.format(this.timeFormat);
                    if( this.isFirstLoad &&
                        this.localDateTo != null &&
                        this.localDateFrom != null &&
                        this.localDateFrom != this.localDateTo
                    ){
                        this.isRange = true;
                    }
                }
            }
        },
        /*
            [WATCHER] When the boolean of specific time is enabled, update the timeEnabled property.
            This is used for not modifying props directly, but used to update the instance with the new boolean value.
        */
        specificTime: {
            immediate: true,
            handler(val) {
                this.timeEnabled = val;
            }
        },
        /*
            [WATCHER] When the boolean for range of dates is selected, update the values of local Dates to nullify them if necessary.
        */
        isRange(value) {
            if(!value) {
                this.localDateTo = this.localDateFrom;
            }else if(value && this.isFirstLoad){
                this.isFirstLoad = false;
            }
            else if(value && !this.isFirstLoad){
                this.localDateTo = null;
            }
        },
        /*
            [WATCHER] When clearing the localDateFrom variable, set as null also the localTimeFrom and the time and date TO variables.
        */
        localDateFrom(value) {
            if(!value) {
                this.localTimeFrom = null;
                this.localDateTo = null;
                this.localTimeTo = null;
            }
        },
        /*
            [WATCHER] When clearing the localDateTo variable, set as null the localTimeTo variable.
        */
        localDateTo(value) {
            if(!value) {
                this.localTimeTo = null;
            }
        }
    },
    methods: {
        datePickerLabel(component) {
            switch(component) {
                case 'DateFrom':
                    return _.isEmpty(this.labelDateFrom) ? this.$t('Common.requestedDate', {type: this.type}) : this.labelDateFrom;
                case 'TimeFrom':
                    return _.isEmpty(this.labelTimeFrom) ? this.$t('Common.from') : this.labelTimeFrom;
                case 'DateTo':
                    return _.isEmpty(this.labelDateTo) ? this.$t('Common.requestedDate', {type: this.type}) : this.labelDateTo;
                case 'TimeTo':
                    return _.isEmpty(this.labelTimeTo) ? this.$t('Common.to') : this.labelTimeTo;
                default:
                    return this.$t('Common.requestedDate', {type: this.type});
            }

        },
        displayableErrors(range) {
            if(this.type === this.$t('Common.pickup'))
                return range=='From' ? {'error-messages': this.errors[`${this.errorsPath}.datePickupFrom`]} :
                                       {'error-messages': this.errors[`${this.errorsPath}.datePickupTo`]} ;
            else if(this.type === this.$t('Common.delivery'))
                return range=='From' ? {'error-messages': this.errors[`${this.errorsPath}.dateDeliveryFrom`]} :
                                       {'error-messages': this.errors[`${this.errorsPath}.dateDeliveryTo`]} ;
            else
                return null;
        }
    },
    created () {
        //SET offsetFrom
        const momentOffsetFrom = moment.parseZone(this.originalValueFrom).utcOffset();
        if(!isNaN(momentOffsetFrom))
        {
             /*
            GENERAL NOTE: Once it gets the offset, the minutes and hours are calculated using absolute values
            since this offset can be negative. This won't affect the offset symbol because the step 5, but for
            the calculation of minutes where we need to substract (get the difference), it helps to use the
            absolute values and remove ambiguities from negative values.
            */
            //1. Get the hours dividing the offset by 60 and rounding it to integers only.
            const hours = Math.abs(Math.round(parseInt(momentOffsetFrom) / 60));
            //2. Get the minutes by substracting the resulting hours (multiplied by 60 to "convert" them to minutes)
            const minutes = (Math.abs(momentOffsetFrom) - (60 * hours));
            //3. Build a valid hours string by adding a 0 before the hours if is one-digit long (less than 10).
            const hoursString = hours > 9 ? hours : "0" + hours;
            //4. Build a valid minutes string by adding a 0 before the minutes if is one-digit long (less than 10).
            const minutesString = minutes > 9 ? minutes : "0" + minutes;
            //5. Calculate the symbol. If is negative, use the minus, if not, use the plus (including for 0).
            const symbol = momentOffsetFrom >= 0 ? "+" : "-";

            //6. Return the build string by using the valid strings.
            //   You should expect output like the following examples:
            //   +00:00 | -02:00  | +11:45  | etc...
            this.offsetFrom = symbol + hoursString + ":" + minutesString;
        }
        else this.offsetFrom = "+00:00";       // Fallback: return an UTC offset (+00:00)
    
        //SET offsetTo
        const momentOffsetTo = moment.parseZone(this.originalValueTo).utcOffset();
        if(!isNaN(momentOffsetTo))
        {
             /*
            GENERAL NOTE: Once it gets the offset, the minutes and hours are calculated using absolute values
            since this offset can be negative. This won't affect the offset symbol because the step 5, but for
            the calculation of minutes where we need to substract (get the difference), it helps to use the
            absolute values and remove ambiguities from negative values.
            */
            //1. Get the hours dividing the offset by 60 and rounding it to integers only.
            const hours = Math.abs(Math.round(parseInt(momentOffsetTo) / 60));
            //2. Get the minutes by substracting the resulting hours (multiplied by 60 to "convert" them to minutes)
            const minutes = (Math.abs(momentOffsetTo) - (60 * hours));
            //3. Build a valid hours string by adding a 0 before the hours if is one-digit long (less than 10).
            const hoursString = hours > 9 ? hours : "0" + hours;
            //4. Build a valid minutes string by adding a 0 before the minutes if is one-digit long (less than 10).
            const minutesString = minutes > 9 ? minutes : "0" + minutes;
            //5. Calculate the symbol. If is negative, use the minus, if not, use the plus (including for 0).
            const symbol = momentOffsetTo >= 0 ? "+" : "-";

            //6. Return the build string by using the valid strings.
            //   You should expect output like the following examples:
            //   +00:00 | -02:00  | +11:45  | etc...
            this.offsetTo = symbol + hoursString + ":" + minutesString;
        }
        else this.offsetTo = "+00:00";       // Fallback: return an UTC offset (+00:00) 
},
}

</script>
